import { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';
import cybleLogo from '../assets/images/lightCybleLogo.svg';
import darkcybleLogo from '../assets/images/darkCybleLogo.svg';
import { AppDispatch } from '../index';
import { userAuthenticationActionCreator } from '../store/UserAuthentication/UserAuthSlice';
import { RootState } from '../configureStore';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import useMeasure from 'react-use-measure';
import storageSession from 'redux-persist/lib/storage/session';
import { useTranslation } from 'react-i18next';
import { RoutePath } from '../helpers/RoutePath';
import { StyledLogoImgNavBar } from './GlobalComponentStyles';
import { ThemeProvider } from 'styled-components';
import { darkTheme, lightTheme } from '../pages/EditProfile/EditProfile';
import { MdOutlineDarkMode, MdOutlineLightMode } from 'react-icons/md';
import darkLogo from '../assets/images/darkCybleLogo.svg';
import lightLogo from '../assets/images/lightCybleLogo.svg';
import { Building2, LogOut, Mails, RotateCw, User } from 'lucide-react';
import LogoutPopup from './LogoutPopup';
import { defaultImg } from '../utils/defaultImgBase64';

type TNavbarProps = ReturnType<typeof mapStateToProps>;

const Navbar = (props: TNavbarProps) => {
  const [navbarRef, { height }] = useMeasure();
  const history = useHistory();
  const dispatch: AppDispatch = useDispatch();
  const [showTooltip, setShowTooltip] = useState(false);
  const companyLogo = useSelector(
    (state: RootState) => state.UserAuthentication.userDetails.user.company_logo
  );
  const host = useSelector((state: RootState) => state.UserAuthentication.host);
  const preferedTheme = useSelector(
    (state: RootState) =>
      state.UserAuthentication?.userDetails?.user?.theme_preference
  );
  const companyName = useSelector(
    (state: RootState) => state.EntityCreation.entityCreation.companyName
  );

  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleLogout = () => {
    dispatch(userAuthenticationActionCreator.handleLogout());
    storageSession.removeItem('persist:root');
    storageSession.removeItem('userTokens');
    storageSession.removeItem('rosiDropDown');
    history.push('/login');
  };
  const currentTheme = useSelector(
    (state: RootState) =>
      state.UserAuthentication.userDetails.user.theme_preference
  );

  useEffect(() => {
    localStorage.setItem('theme', currentTheme);
  }, [currentTheme]);

  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (host !== window.location.hostname) {
      const callLogout = () => {
        dispatch(userAuthenticationActionCreator.handleLogout());
        storageSession.removeItem('persist:root');
        storageSession.removeItem('userTokens');
        history.push('/login');
      };
      callLogout();
    } else return;
  }, [dispatch, history, host]);

  useEffect(() => {
    document.body.style.setProperty('--nav-height', `${height}px`);
  }, [height]);

  if (
    // !location?.pathname.includes('SecurityPulseDetail') &&
    !location.pathname.split('/').includes('Share')
  ) {
    return (
      <>
        <nav
          ref={navbarRef}
          id={
            location?.pathname !== '/SecurityPulseGrid' &&
            location?.pathname !== '/maturityAssessmentDashboard'
              ? 'section-to-print'
              : ''
          }
          className='navbar navbar-expand-lg navbar-dark'
        >
          <NavLink
            className='navbar-brand font-italic cursor-pointer outline-none border-none'
            to='/'
          >
            {companyLogo ? (
              <div className='d-flex justify-content-center align-items-center gap-point-5'>
                <StyledLogoImgNavBar
                  showShadow={false}
                  width='2em'
                  className='acme macme'
                  src={companyLogo}
                  style={{ marginLeft: 'auto' }}
                  alt='Tenant Logo'
                />
                <div>
                  <p
                    className='text-start mb-0 fst-normal font-size-point-875-rem font-weight-600'
                    style={{
                      color: 'var(--font-color)',
                    }}
                  >
                    {companyName
                      ?.toLowerCase()
                      .replace(/\b\w/g, (char) => char?.toUpperCase())}
                  </p>
                  <p className='fs-10-px mb-0 text-end fst-normal muted-color'>
                    {t('powered_by')}{' '}
                    <img
                      src={currentTheme === 'dark' ? lightLogo : darkLogo}
                      alt='NETRUM - Cyble'
                    />
                  </p>
                </div>
              </div>
            ) : (
              <StyledLogoImgNavBar
                showShadow={false}
                className='acme macme'
                src={currentTheme === 'light' ? darkcybleLogo : cybleLogo}
                alt=''
                width='8em'
              />
            )}
          </NavLink>

          {/* //new nav  */}
          {props.UserData.isLoggedIn && (
            <div
              className='show justify-content-end'
              id='navbarSupportedContent'
            >
              <div
                style={{ paddingRight: '1.5rem' }}
                className=' text-white cursor-pointer d-flex align-items-center'
              >
                <Col>
                  <ThemeProvider
                    theme={preferedTheme === 'dark' ? darkTheme : lightTheme}
                  >
                    {preferedTheme === 'light' ? (
                      <MdOutlineLightMode
                        color='black'
                        onClick={() => {
                          const themeVar =
                            preferedTheme === 'light' ? 'dark' : 'light';
                          dispatch(
                            userAuthenticationActionCreator.updateTheme({
                              theme_preference: themeVar,
                            })
                          );
                        }}
                      />
                    ) : (
                      <MdOutlineDarkMode
                        color='white'
                        onClick={() => {
                          const themeVar =
                            preferedTheme === 'light' ? 'dark' : 'light';
                          dispatch(
                            userAuthenticationActionCreator.updateTheme({
                              theme_preference: themeVar,
                            })
                          );
                        }}
                      />
                    )}
                  </ThemeProvider>
                </Col>
                <Col className='pr-0'>
                  <Link
                    className={`nav-link dropdown-toggle py-0 control d-flex justify-content-end ${companyName ? 'align-items-end' : 'align-items-center'}`}
                    to='#'
                    id='navbarDropdown'
                    role='button'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'
                    data-tip
                    data-for='userName'
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => {
                      setShowTooltip(false);
                    }}
                  >
                    <div className='mx-2 username-navbar'>
                      <span className='fw-500 font-size-point-875-rem'>
                        {props.UserData.userDetails?.user?.first_name +
                          ' ' +
                          props.UserData.userDetails?.user?.last_name}
                      </span>
                      <span className='font-size-point-75-rem'>
                        {companyName
                          ?.toLowerCase()
                          .replace(/\b\w/g, (char) => char?.toUpperCase())}
                      </span>
                    </div>
                    {props?.UserData?.userDetails?.user?.profile_photo?.trim() !=
                    defaultImg?.trim() ? (
                      <img
                        style={{
                          width: '35px',
                          height: '35px',
                          borderRadius: '50%',
                          marginBottom: '2px',
                        }}
                        src={props?.UserData?.userDetails?.user?.profile_photo}
                        alt='Profile Photo'
                      />
                    ) : (
                      <span
                        style={{
                          backgroundColor: 'var(--muted-bg-color)',
                          borderRadius: '6px',
                          padding: '6px',
                        }}
                      >
                        <User color='var(--font-color)' size={20} />

                        {showTooltip && (
                          <ReactTooltip id='userName' place='bottom'>
                            {props.UserData.userDetails?.user?.first_name +
                              ' ' +
                              props.UserData.userDetails?.user?.last_name}
                          </ReactTooltip>
                        )}
                      </span>
                    )}
                  </Link>

                  <div
                    className='dropdown-menu navbar-user mobile-nav-dropdown text-center '
                    aria-labelledby='navbarDropdown'
                  >
                    <NavLink
                      className='dropdown-item py-2  text-left '
                      to={RoutePath.EDITPROFILE}
                    >
                      <User size={20} className='mr-2' />
                      <span className='EditProfileDropDown '>
                        {t('myprofile')}
                      </span>
                    </NavLink>
                    <NavLink
                      className='dropdown-item py-2  text-left '
                      to={RoutePath.ORGANIZATION}
                    >
                      <Building2 size={20} className='mr-2' />
                      <span className='EditProfileDropDown '>
                        {t('organization')}
                      </span>
                    </NavLink>
                    <NavLink
                      className='dropdown-item py-2 text-left '
                      to={RoutePath.RESETPASSWORD}
                    >
                      <RotateCw size={20} className='mr-2' />
                      <span className='EditProfileDropDown'>
                        {t('resetpassword')}
                      </span>
                    </NavLink>

                    <NavLink
                      className='dropdown-item py-2 text-left '
                      to={RoutePath.CONTACT}
                    >
                      <Mails size={20} className='mr-2' />
                      <span className='EditProfileDropDown'>
                        {' '}
                        {t('contactus')}
                      </span>
                    </NavLink>
                    <div
                      className='dropdown-item py-2 text-left'
                      onClick={() => setOpenModal(true)}
                    >
                      <LogOut size={20} className='mr-2' />
                      <span className='EditProfileDropDown'>{t('logout')}</span>
                    </div>
                  </div>
                </Col>
              </div>
            </div>
          )}
        </nav>
        {openModal && (
          <LogoutPopup
            setOpenModal={setOpenModal}
            handleLogout={handleLogout}
          />
        )}
      </>
    );
  } else {
    return <></>;
  }
};

// export default Navbar;
function mapStateToProps(state: RootState) {
  return {
    UserData: state.UserAuthentication,
    SecurityPulseDetail: state.SecurityPulseDetails,
  };
}

export default connect(mapStateToProps)(Navbar);
